import React, { useState } from "react";
import { Button } from "react-bootstrap";

import MultipleMatchResolver from "../../../CheckoutPage/components/MultipleMatchResolver";
import StudentProfileCard from "../../../Immunizations/components/widgets/StudentProfileCard";

const ReviewModalButton = ({ props, testGroup }) => {
    const {
      id: testGroupUserId,
      required_immunizations_status: requiredImmunizationStatus,
      user,
      review_url: reviewUrl,
    } = props;
    const buttonVariant = 'outline-secondary';
    const buttonSize = 'sm';
    const [immunizationStatus, setImmunizationStatus] = useState(
      requiredImmunizationStatus
    );

    if (immunizationStatus === 'multiple_matches') {
      return (
        <MultipleMatchResolver
          onMatchSelected={async () => {
            try {
              const response = await requestHistoryUpdate({
                testGroupId: testGroup.id,
                userId: user.id,
              });
              setImmunizationStatus('pending');
              window.location.reload(false);
              // re-calculate immunization compliance
            } catch (error) {
              console.log('error');
            }
          }}
          resolveButtonVariant={buttonVariant}
          resolveButtonSize={buttonSize}
          testGroupId={testGroup.id}
          user={user}
          modalSubtitle="Please select the correct student."
          nameColumnAlias="Student"
          recordDetails={
            <StudentProfileCard
              user={user}
              testGroupSlug={testGroup.slug}
              testGroupUserId={testGroupUserId}
            />
          }
        />
      );
    } else {
      return (
        <Button
          href={reviewUrl}
          size={buttonSize}
          variant={buttonVariant}
        >
          Review
        </Button>
      );
    }
};

export default ReviewModalButton;